import { useQuery } from '@tanstack/react-query';
import type { AgentApiProvidedJobPostsIndex } from '@/types/serializers';

/**
 * KPI カード用に「稼動求人」の総件数のみを取得する軽量フック。
 * provided_job_posts index API を 1 ページ目だけ叩き、`total_count` のみ参照する。
 */
export default function useFetchProvidedJobPostCount() {
  return useQuery({
    queryKey: ['/agent/api/provided_job_posts', 'count'],
    queryFn: async () => {
      const response = await fetch('/agent/api/provided_job_posts.json?page=1');
      if (!response.ok) {
        throw new Error('稼動求人数の取得に失敗しました');
      }
      const data: AgentApiProvidedJobPostsIndex = await response.json();
      return data.total_count;
    },
  });
}
